// EmailJS configuration
// Configuration values are loaded from environment variables (.env file)
// Get these from: https://dashboard.emailjs.com/admin/integration

export const emailConfig = {
  // EmailJS Public Key (found in Account > General)
  publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "",

  // EmailJS Service ID (found in Email Services)
  serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID || "",

  // EmailJS Template IDs (found in Email Templates)
  templates: {
    // General contact form template (used for all forms)
    contact: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "",

    // Book a tour form template (disabled - using contact template)
    bookTour: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "",

    // FAQ contact form template (disabled - using contact template)
    faq: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "",

    // Newsletter subscription template (disabled - using contact template)
    newsletter: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "",
  },

  // To email address (the email that will receive the form submissions)
  toEmail: process.env.REACT_APP_EMAILJS_TO_EMAIL || "",
};

// EmailJS Setup Instructions:
// 1. Go to https://www.emailjs.com/ and create a free account
// 2. Add an Email Service (Gmail, Outlook, etc.)
// 3. Create Email Templates for each form
//    - Contact form: Include {{from_name}}, {{from_email}}, {{phone}}, {{institution}}, {{interested_products}}, {{message}}, {{tour_type}} (if applicable)
//    - Book Tour: Include {{name}}, {{email}}, {{tourType}}, {{message}}
//    - FAQ: Include {{name}}, {{email}}, {{message}}
//    - Newsletter: Include {{email}}
// 4. Get your Public Key from Account > General
// 5. Copy Service ID and Template IDs from their respective pages
// 6. Update this config file with your actual values
